import {
  acceptRequest,
  addRequest,
  deleteRequest,
  parseRequestDoc,
  rejectRequest,
} from '@db/Requests/Common';
import { getCurrentUserId } from '@helpers/firebase/Auth';
import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { RequestStatus, RequestType } from '@types';

export async function addJoinPlanRequest(planId: string) {
  const currentUserId = getCurrentUserId();
  return await addRequest({
    userId: currentUserId,
    entityId: planId,
    type: RequestType.JOIN_PLAN,
  });
}

export async function acceptJoinPlanRequest(planId: string, userId: string) {
  return await acceptRequest({
    userId,
    entityId: planId,
    type: RequestType.JOIN_PLAN,
  });
}

export async function rejectJoinPlanRequest(planId: string, userId: string) {
  return await rejectRequest({
    userId,
    entityId: planId,
    type: RequestType.JOIN_PLAN,
  });
}

export async function deleteJoinPlanRequest(planId: string, userId: string) {
  return await deleteRequest({
    userId,
    entityId: planId,
    type: RequestType.JOIN_PLAN,
  });
}

export function listenToPendingJoinPlanRequestPlanIds(
  onSnapshot: (planIds: Set<string>) => void,
  onError: (error: db.FirestoreError) => void
) {
  const currentUserId = getCurrentUserId();
  const query = db.query(
    db.collection(firestore, 'requests'),
    db.where('userId', '==', currentUserId),
    db.where('type', '==', RequestType.JOIN_PLAN),
    db.where('status', '==', RequestStatus.PENDING)
  );

  return db.onSnapshot(
    query,
    (snapshot) => {
      const entityIds = snapshot.docs.map((doc) => parseRequestDoc(doc).entityId);
      onSnapshot(new Set(entityIds));
    },
    onError
  );
}

export async function getPendingJoinPlanRequestUserIds(planId: string) {
  const query = db.query(
    db.collection(firestore, 'requests'),
    db.where('entityId', '==', planId),
    db.where('type', '==', RequestType.JOIN_PLAN),
    db.where('status', '==', RequestStatus.PENDING)
  );

  const snap = await db.getDocs(query);
  return snap.docs.map((doc) => parseRequestDoc(doc).userId);
}
